export const DEFAULT_PAGE_SIZE = 50;
export const EVALUATIONS_PAGE_SIZE = 100;
export const DEFAULT_DATE_RANGE_DAYS = 7;

export const EXPORT_PERFORMANCE_LIMIT = 50000;
export const EXPORT_EVALUATIONS_LIMIT = 50000;

export const MILLISECONDS = {
  SECOND: 1000,
  MINUTE: 60 * 1000,
  HOUR: 60 * 60 * 1000,
  DAY: 24 * 60 * 60 * 1000,
} as const;

export function daysAgo(days: number): Date {
  return new Date(Date.now() - days * MILLISECONDS.DAY);
}
